import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { IconTrack } from '@spotify-internal/encore-creator-web';
import { sendEvent } from '@mrkt/features/Platform/googleAnalytics';
import { numFormatting } from '../../HomeHelper';
import * as Style from '../Style';
import StatsSubHeader from '../StatsSubHeader';
import StatsCTABtn from '../StatsCTABtn';

const SongTitle = styled(Style.StatsMediaTitle)`
  padding-bottom: 3px; /* space for focus state */
`;

const TopSongs = React.memo(props => {
  const { topSongs } = props;

  const TopHeader = (
    <StatsSubHeader title="Your top songs" dataTitle="streams" />
  );

  const AllSongsBtn = (
    <StatsCTABtn
      url={`/artist/${props.artist.id}/music/songs?time-filter=7day`}
      action="songs"
      label="goToSongs"
      title="See songs"
    />
  );

  if (topSongs.length > 0) {
    return (
      <div data-testid="tsongs">
        {TopHeader}
        {topSongs.slice(0, 3).map(track => (
          <Style.StatsRowContainer
            data-testid="tsongs-row"
            hover
            key={track.trackUri}
            isDisabled={track.isDisabled}
            title={
              track.isDisabled
                ? "This song isn't part of your current catalog"
                : null
            }
            onClick={() => {
              if (track.isDisabled) return;

              sendEvent({
                eventCategory: 'Navigate',
                eventAction: 'songs',
                eventLabel: `${track.trackUri}`,
              });

              const segmentFilter = 'streams';

              props.history.push(
                `/artist/${props.artist.id}/song/${track.trackUri.replace(
                  `spotify:track:`,
                  ``,
                )}?segment-filter=${segmentFilter}&time-filter=7day`,
              );
            }}
          >
            <Style.StatsRow>
              <Style.StatsMediaEntity>
                <Style.StatsMediaCover
                  imgSrc={track.pictureUri}
                  size={48}
                  defaultIcon={<IconTrack size={24} />}
                />
                <Style.StatsMediaInfo>
                  <SongTitle>
                    {track.isDisabled ? (
                      track.trackName
                    ) : (
                      <Style.StatsTextLink href="#">
                        {track.trackName}
                      </Style.StatsTextLink>
                    )}
                  </SongTitle>
                </Style.StatsMediaInfo>
              </Style.StatsMediaEntity>
              <Style.StatsDeltaContainer>
                <Style.StatsDeltaTitle>
                  {numFormatting(track.numStreams)}
                </Style.StatsDeltaTitle>
              </Style.StatsDeltaContainer>
            </Style.StatsRow>
          </Style.StatsRowContainer>
        ))}
        {AllSongsBtn}
      </div>
    );
  }

  return (
    <React.Fragment>
      {TopHeader}
      <Style.StatsEmptyText data-testid="empty-songs">
        No stats for this time period. Stats appear when a song has at least 10
        listeners within the last 7 days.
      </Style.StatsEmptyText>
      {AllSongsBtn}
    </React.Fragment>
  );
});

TopSongs.propTypes = {
  artist: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  topSongs: PropTypes.arrayOf(
    PropTypes.shape({
      trackName: PropTypes.string,
      pictureUri: PropTypes.string,
      trend: PropTypes.number,
      numListeners: PropTypes.number,
      numStreams: PropTypes.number,
      trackUri: PropTypes.string,
      isDisabled: PropTypes.boolean,
    }),
  ),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

/* eslint-disable-next-line import/no-default-export */
export default TopSongs;
